import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 16v-8l3 5l3 -5v8","key":"svg-1"}]]

const IconCircleLetterM = createReactComponent('outline', 'circle-letter-m', 'CircleLetterM', __iconNode);

export default IconCircleLetterM;